import React from 'react';
import Icon from '../../../components/AppIcon';

const UserAnalyticsKPIs = ({ kpis }) => {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {kpis?.map((kpi) => (
        <div key={kpi?.label} className="bg-card border border-border rounded-xl p-4 flex flex-col gap-3">
          <div className="flex items-center justify-between">
            <div className="w-9 h-9 rounded-lg flex items-center justify-center" style={{ backgroundColor: `${kpi?.color}18` }}>
              <Icon name={kpi?.icon} size={18} color={kpi?.color} />
            </div>
            <div className={`flex items-center gap-1 text-xs font-medium px-2 py-0.5 rounded-full ${
              kpi?.changeType === 'positive' ? 'bg-success/10 text-success' :
              kpi?.changeType === 'negative'? 'bg-error/10 text-error' : 'bg-muted text-muted-foreground'
            }`}>
              <Icon
                name={kpi?.changeType === 'positive' ? 'TrendingUp' : kpi?.changeType === 'negative' ? 'TrendingDown' : 'Minus'}
                size={11}
              />
              {kpi?.change}
            </div>
          </div>
          <div>
            <p className="text-2xl font-bold text-foreground leading-none">{kpi?.value}</p>
            <p className="text-xs text-muted-foreground mt-1">{kpi?.label}</p>
          </div>
          {kpi?.sub && (
            <p className="text-xs text-muted-foreground border-t border-border pt-2">{kpi?.sub}</p>
          )}
        </div>
      ))}
    </div>
  );
};

export default UserAnalyticsKPIs;
